var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Rule"},[_c('r_header'),_c('side_bar',{attrs:{"links":_vm.links}}),_c('div',{staticClass:"markdown"},[_c('div',{staticClass:"md"},[_c('vue_markdown',{attrs:{"source":_vm.rule}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }